// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1gJPa","actions":"GroupTable_actions__U5ciP","deleteModalFooter":"GroupTable_deleteModalFooter__1eaK_"};